import {Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {UntypedFormBuilder, Validators} from "@angular/forms";
import {Company} from "../../company/company.model";
import {Country} from "../../country/country.model";
import {FormComponent} from "../form.component";
import {CountryService} from "../../country/country.service";
import {I18NextService} from "angular-i18next";
import {streetNumberSpacingValidator} from "../../myshared/streetValidator";

type Form = {
  name: string;
  street: string;
  street2: string;
  zip: string;
  city: string;
  country: string;
  email?: string;
  electronic_invoice_email?: string;
  vat?: string;
}

@Component({
    selector: 'app-company-form',
    templateUrl: './company-form.component.html',
    styleUrls: [],
    standalone: false
})
export class CompanyFormComponent extends FormComponent<Company> {

  @Input() showVat: boolean = true;
  @Input() showInvoiceMail: boolean = true;
  @Input() showElectronicInvoiceMail: boolean = true;
  @Input() company?: Company;
  @Input() countries: Country[];
  @Input() isCountryChangeable: boolean = true;
  @Input() isNameChangeable: boolean = true;
  @Input() submitButtonLabel = 'app_update';

  private isCountryTraced: boolean = false;

  constructor(protected fb: UntypedFormBuilder, protected i18next: I18NextService, private countryService: CountryService) {
    super(fb, i18next);
  }

  public formMapper(form: Form): Company {
    const company = Company.fromJson(form);

    company.country = !this.isCountryChangeable
      ? this.company.country
      : this.countries.find(country => country.code === form.country);
    company.id = this.company?.id ?? '';

    return company;
  }

  protected createForm() {
    this.form = this.fb.group({
      name: [{value: this.company?.name ?? '', disabled: !this.isNameChangeable}, Validators.required],
      street: [this.company?.street ?? '', [Validators.required, streetNumberSpacingValidator]],
      street2: [this.company?.street2 ?? ''],
      zip: [this.company?.zip ?? '', Validators.required],
      city: [this.company?.city ?? '', Validators.required],
      country: [{ value: this.company?.country?.code ?? 'DE', disabled: !this.isCountryChangeable}, Validators.required],
      email: this.showInvoiceMail ? ([this.company?.email ?? '', [Validators.required, Validators.email]]) : undefined,
      electronic_invoice_email: this.showElectronicInvoiceMail ? ([this.company?.electronic_invoice_email ?? '', Validators.email]) : undefined,
      vat: this.showVat ? (this.company?.vat ?? '') : undefined,
    })

    // If we do not have a country, try to check where the customer lives
    if (!this.isCountryTraced && this.countries?.length > 0 && !this.company?.country?.code && this.isCountryChangeable) {
      this.countryService.traceCountry().subscribe((code: any) => {
        const country = this.countries.find((c: Country) => c.code.toUpperCase() === code.toUpperCase());
        this.form.get('country').setValue(country?.code ?? 'DE');
        this.isCountryTraced = true;
      });
    }
  }
}
